import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics } from 'component-library/__styling/settings'
import { transition } from 'component-library/__styling/style-mixins'
import { WebNavLink } from 'common/navigation/web-link'
import { IconUser } from 'component-library/icons/IconUser/IconUser'
import { StyledComponent } from '@emotion/styled'

export const StyledFlyoutNavActions = styled('div')({
    display: 'flex',
    flexShrink: 0,
    padding: calcRem(0, 13),
    marginBottom: calcRem(metrics.thewest.margins.md),
})

export const StyledActionLink = styled(WebNavLink)(
    {
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 0,
        alignItems: 'center',
        justifyContent: 'center',
        padding: calcRem(4, metrics.thewest.margins.sm),
        borderRadius: 2,
        border: 'none',
        color: colors.white,
        outline: 'none',
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: 'uppercase',
        ...transition({ properties: ['background-color', 'color'] }),

        '&:not(:first-child)': {
            marginLeft: calcRem(metrics.thewest.margins.md),
        },

        '&:hover': {
            backgroundColor: colors.thewest.greyElephant,
        },

        '&:focus': {
            backgroundColor: colors.thewest.greyElephant,
            textDecoration: 'underline',
        },
    },
    ({ theme }) => ({
        backgroundColor: theme.sectionValues.primaryColor,
    })
)

export const StyledActionButton = StyledActionLink.withComponent('button') as StyledComponent<
    JSX.IntrinsicElements['button']
>

export const StyledActionLinkOutline = styled(StyledActionLink)({
    backgroundColor: 'transparent',
    border: `1px solid ${colors.white}`,
    cursor: 'pointer',

    '&:focus': {
        backgroundColor: colors.thewest.greyElephant,
        borderColor: colors.thewest.greyElephant,
    },

    '&:hover': {
        backgroundColor: colors.white,
        color: colors.thewest.greyGorilla,
    },
})

export const StyledActionLinkOutlineButton = StyledActionLinkOutline.withComponent(
    'button'
) as StyledComponent<JSX.IntrinsicElements['button']>
export const StyledActionLinkOutlineSkeleton = StyledActionLinkOutline.withComponent(
    'span'
) as StyledComponent<{}>

export const StyledUserLink = styled(StyledActionLink)({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    overflow: 'hidden',
})

export const StyledUserName = styled('span')({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
})

export const StyledIconUser = styled(IconUser)({
    width: calcRem(20),
    height: calcRem(20),
    flexShrink: 0,
    marginLeft: calcRem(8),
    verticalAlign: 'middle',
    stroke: colors.white,
})
